export const GRAPHQL_VARIABLES = {
  record: {
    email: 'some.new.email@bookipi.com'
  },
  filter: {
    _id: '5fc44ddb84ffd06759c1a1ef'
  }
};

export const QUERY = `
  mutation vendorsUpdateOne ($record: UpdateOnevendorsInput!, $filter: AutoFilledFilterUpdateOnevendorsInput!, $sort: SortUpdateOnevendorsInput, $skip: Int) {
    vendorsUpdateOne (record: $record, filter: $filter, sort: $sort, skip: $skip) {
        recordId
        record {
            email
            phone
            firstName
            lastName
            companyName
            address {
                address1
                address2
                address3
                state
                city
                zip
                country
                _id
            }
            companyId
            bpCompany
            _id
            updatedAt
            createdAt
        }
        error {
            message
        }
    }
  }
`;
